import { ReactComponent as AppLogo } from 'src/assets/icons/logo.svg';
import { ReactComponent as Notification } from 'src/assets/icons/notification.svg';
import { ReactComponent as Dashboard } from 'src/assets/icons/dashboard.svg';
import { ReactComponent as YourCampaign } from 'src/assets/icons/campaign.svg';
import { ReactComponent as CreativeDeveloper } from 'src/assets/icons/creative-developer.svg';
import { ReactComponent as YourAccount } from 'src/assets/icons/your-account.svg';
import { ReactComponent as AccountSetup } from 'src/assets/icons/account-setup.svg';
import { ReactComponent as Logout } from 'src/assets/icons/logout.svg';
import { ReactComponent as SideMenu } from 'src/assets/icons/side-menu.svg';
import { ReactComponent as Eye } from 'src/assets/icons/eye.svg';
import { ReactComponent as HidePasswordEye } from 'src/assets/icons/hidePasswordEye.svg';
import { ReactComponent as LeftArrow } from 'src/assets/icons/leftArrow.svg';
import { ReactComponent as Plus } from 'src/assets/icons/plus.svg';
import { ReactComponent as Upload } from 'src/assets/icons/upload.svg';
import { ReactComponent as Filter } from 'src/assets/icons/filter.svg';
import { ReactComponent as BarChart } from 'src/assets/icons/barChartIcon.svg';
import { ReactComponent as TrendIcon } from 'src/assets/icons/trendIcon.svg';
import { ReactComponent as DollarCycleIcon } from 'src/assets/icons/dollarCycleIcon.svg';
import { ReactComponent as Connected } from 'src/assets/icons/connected.svg';
import { ReactComponent as Proceed } from 'src/assets/icons/proceed.svg';
import { ReactComponent as Mouse } from 'src/assets/icons/mouse-icon.svg';
import { ReactComponent as Amex } from 'src/assets/icons/amex.svg';
import { ReactComponent as DefaultCard } from 'src/assets/icons/default-card.svg';
import { ReactComponent as Diners } from 'src/assets/icons/diners.svg';
import { ReactComponent as Discover } from 'src/assets/icons/discover.svg';
import { ReactComponent as Jcb } from 'src/assets/icons/jcb.svg';
import { ReactComponent as Mastercard } from 'src/assets/icons/mastercard.svg';
import { ReactComponent as Visa } from 'src/assets/icons/visa.svg';
import { ReactComponent as ObjectiveWhite } from 'src/assets/icons/objectiveWhite.svg';
import { ReactComponent as ObjectiveBlue } from 'src/assets/icons/objectiveBlue.svg';
import { ReactComponent as Hand } from 'src/assets/icons/hand.svg';
import { ReactComponent as Copyright } from 'src/assets/icons/copyright.svg';
import { ReactComponent as Check } from 'src/assets/icons/check.svg';
import { ReactComponent as CrmLinking } from 'src/assets/icons/crmLinking.svg';
import { ReactComponent as Sort } from 'src/assets/icons/sort.svg';


interface IconSvgProps {
  icon: Icons;
  className?: string;
  [key: string]: any;
}

const icons = Object.freeze({
  appLogo: AppLogo,
  notification: Notification,
  dashboard: Dashboard,
  yourCampaign: YourCampaign,
  creativeDeveloper: CreativeDeveloper,
  yourAccount: YourAccount,
  accountSetup: AccountSetup,
  logout: Logout,
  sideMenu: SideMenu,
  eye: Eye,
  hidePasswordEye: HidePasswordEye,
  leftArrow: LeftArrow,
  plus: Plus,
  upload: Upload,
  filter: Filter,
  barChart: BarChart,
  trendIcon: TrendIcon,
  dollarCycleIcon: DollarCycleIcon,
  connected: Connected,
  proceed: Proceed,
  mouse: Mouse,
  amex: Amex,
  defaultCard: DefaultCard,
  diners: Diners,
  discover: Discover,
  jcb: Jcb,
  mastercard: Mastercard,
  visa: Visa,
  objectiveWhite: ObjectiveWhite,
  objectiveBlue: ObjectiveBlue,
  hand: Hand,
  copyright: Copyright,
  check: Check,
  crmLinking: CrmLinking,
  sort: Sort
});

export type Icons = keyof typeof icons;

const IconSvg = ({ icon, className, ...rest }: IconSvgProps) => {
  const SvgIcon = icons[icon];
  if (!SvgIcon) {
    console.error(`Invalid icon: ${icon}`);
    return null; // or return a default icon
  }

  return <SvgIcon className={className} {...rest} />;
};

export default IconSvg;
